module.exports = __webpack_public_path__ + "static/img/YINXZ.11206472.jpg";